import BlogPage from 'src/views/Marketing/Blog/components/BlogPage';
import Footer from 'src/views/Marketing/components/Footer';
import NavBar from 'src/views/Marketing/components/NavBar';
import { ScrollView, StyleSheet } from 'react-native';
import * as Constants from 'src/constants';

export default function Page() {
  return (
    <ScrollView style={styles.scrollView}>
      <NavBar />
      <BlogPage
        author='OneShop Team'
        dateTime='2022-11-09'
        tag='Depop'
        title='Selling On Depop? 10 Effective Tips for Listing on Depop'
      >
        <h3>1. Always have the brand name in the title.</h3>
        <p>
          Consumers, especially the majority of the young generation, are brand conscious. Apart from looking for
          clothes or items that fancy their eyes, the next thing they look at and ask for is the brand of a particular
          item.
        </p>
        <p>
          We all know that branded items are not only appealing but are also considered quality items. They don't easily
          get damaged as they have gone through thorough design and manufacturing processes. That is why many consider
          designers as priced items—it's no surprise they usually cost more.
        </p>
        <p>
          It is best to include the brand name of your items and even show the logo in the photo to have an edge in your
          offerings. This proves the authenticity of your items as potential buyers often can detect fake branded
          products as well.
        </p>

        <h3>2. Do not spam irrelevant hashtags.</h3>
        <p>
          When you scroll through the Depop website, you will notice that some Depop sellers crowd their listings with
          keywords and hashtags. These two are helpful for buyers in narrowing down their search for the products they
          want. However, if you overdo it to the point that you place keywords irrelevant to your item, potential buyers
          would feel cheated or lied to and would therefore be discouraged from making a purchase. For instance, you
          should not place hashtags like #poloshirt or #shirt when selling a floral-print blouse for women.
        </p>

        <h3>3. Do use effective and popular hashtags in the description.</h3>
        <p>
          As previously mentioned, using hashtags surely increases your chances of selling your products. Buyers
          nowadays search for products using these words. An effective way to incorporate this into your listings is to
          use the relevant keywords. Make sure that popular hashtags are still closely related to your item, correctly
          describing it and categorizing it. For instance, if you are selling Lacoste jeans, your hashtags should be
          #jeans, #pants, #Lacoste, #denim, #blackjeans, and so forth.
        </p>
        <p>
          Additionally, avoid repetitive keywords. If you have already used #shoes on a listing, don't add it again on
          the same list. You may change it by being specific: #shoesformen or #shoesforwomen.
        </p>

        <h3>4. Be transparent about any flaws and conditions in the listing.</h3>
        <p>
          Nothing turns a client away faster than deception on an item you're selling. They expect to receive the
          products they bought based on the specified details. That is why it is important to be upfront in your
          descriptions of the item's condition.
        </p>
        <p>
          Be sure to indicate if there are signs of wear, a minor scratch, or slight damage. When you are honest, it
          gives you more credibility, and more Depop users would know and trust you for this.
        </p>

        <h3>5. Add measurements, as sizes can vary between brands.</h3>
        <p>
          It is known that sizes vary between brands in different countries, even in the US and UK. A size indicating S
          for small, M for Medium, L for Large, and XL for Extra Large does not necessarily mean it would fit
          individuals based on their body type. This may be attributed to why different clothing companies use different
          models and model shots. Finding clothes that would give one a perfect fit is a challenge.
        </p>
        <p>
          In your postings, including clothes measurements would definitely be an advantage. Buyers would discern right
          away if the item they are eyeing would fit well and look good on them. Additionally, this trims down their
          search for the perfect clothing for them.
        </p>
        <p>
          These will both benefit the buyer and you as a seller, as you will no longer waste time answering repetitive
          queries about the sizes.
        </p>

        <h3>6. Take good photos.</h3>
        <p>
          The buyers' first impression of your offerings is the make or break of a possible sale. Therefore, it is
          important to put extra effort into taking photos of your products.
        </p>
        <p>
          Take a look at fashion photos posted on Instagram and Pinterest, especially by Gen Z. These two apps and
          platforms are known for having attractive and professional-looking images.
        </p>
        <p>
          Having natural light is one of the keys to taking great pictures. Make it a point to take your photos near
          windows or glass doors. If, however, this is not possible, invest in a lighting kit. You might also consider
          shooting outdoors as there is plenty of natural light.
        </p>
        <p>
          It is best to do flat lays for items that are not clothes. You can do these by placing the products against a
          plain background like a floor or by the wall. When there is minimal noise behind, buyers are more focused on
          the quality and beauty of your item.
        </p>

        <h3>
          7. Depop listing allows sellers to upload up to four (4) photos of your item. Doing so allows the buyer to
          have a clearer view of your products and better understand their purchases.
        </h3>
        <p>
          Taking different kinds of photos also assists in advertising your products well. Keep in mind that the first
          photo is the most important as this is the first one that buyers will set their eyes on. It is also best to
          have close-ups showing the tags or any flaw in the product.
        </p>
        <p>
          For example, if your items are t-shirts, you can have someone you know model them for you. Take front and back
          shots, close-ups of the material or other details, and lastly, angles you want to emphasize.
        </p>
        <p>
          Above all, take note that you don't need professional photography equipment to do all these. Your IOS/iPhone
          or Android phone can suffice.
        </p>

        <h3>8. Respond to Questions Quickly.</h3>
        <p>
          Apart from taking and uploading good images, you must include all pertinent details of your products. However,
          there will still be instances where prospective buyers will still message you for inquiries. It is important
          to respond to them right away, or at least in a reasonable time frame. In this way, the possibility of having
          a sale is high because the buyer may be in a buying decision moment at the time of the inquiry.
        </p>
        <p>
          Moreover, you can settle a dispute right away or any other question about fees, shipping costs, and sold
          items.
        </p>

        <h3>9. Constantly post new items.</h3>
        <p>
          As a seller, it will be to your advantage if you post new items for sale on a daily basis and, in turn, expand
          your inventory. This way, your followers will see your feed every day. Prospective clients flock to your
          listings, but they can see your previous listings, which have a big chance of having Depop sales.
        </p>
        <p>
          Most often, sellers have many items to list. It is to your advantage to post limited items daily rather than
          posting several items that may get lost in your feed, thus losing their chance of being seen and purchased.
        </p>
        <p>As always, quality is better than quantity when catching people's eyes!</p>

        <h3>10. Crosslist to multiple marketplaces.</h3>
        <p>
          Boosting your sales isn't only limited to Depop. If you wish to put your listings in front of a wider
          audience, then you should consider crosslisting to other marketplaces like Poshmark, Mercari, Tradesy, and
          eBay. Doing so can give you a higher chance of coming across the right buyer for your item, as each platform
          means a new market. Also, by crosslisting, you can take advantage of comparison shopping to compete with other
          sellers with similar items at a lower price.{' '}
        </p>
        <p>
          Thousands of resellers do this with the help of a reliable automation service like OneShop. So, instead of
          dreading the long hours of manually drafting each of your Depop listings again, it isn't a problem anymore.{' '}
        </p>
        <p>
          With OneShop, you can easily import your Depop listings and crosslist them on every site OneShop supports.
          Other features like automatic delisting, sales tracker, monthly goals, and RN lookup are also available to all
          its subscribers.
        </p>
        <p>
          Furthermore, Depop AutoBump will be available on OneShop soon. This feature can help you boost your listings'
          visibility enabling you to reach more potential buyers with minimal work.
        </p>
        <p>
          Try OneShop and get first-hand experience on how automation can free up your time. Start your 7-day free trial
          today by signing up <a href='https://tools.oneshop.com/signup'>here</a>.
        </p>
      </BlogPage>
      <Footer />
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  scrollView: {
    flex: 1,
  },
});
